var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.000000 0.000000 96.000000 96.000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Suitcase",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 12.000000 26.000000 C 9.800000 26.000000 8.000000 27.799999 8.000000 30.000000 L 8.000000 78.000000 C 8.000000 80.199997 9.800000 82.000000 12.000000 82.000000 L 20.000000 82.000000 L 20.000000 26.000000 L 12.000000 26.000000 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 84.000000 26.000000 L 76.000000 26.000000 L 76.000000 82.000000 L 84.000000 82.000000 C 86.199997 82.000000 88.000000 80.199997 88.000000 78.000000 L 88.000000 30.000000 C 88.000000 27.799999 86.199997 26.000000 84.000000 26.000000 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 61.000000 26.000000 L 61.000000 21.000000 C 61.000000 17.100000 57.900002 14.000000 54.000000 14.000000 L 48.000000 14.000000 L 42.000000 14.000000 C 38.099998 14.000000 35.000000 17.100000 35.000000 21.000000 L 35.000000 26.000000 L 24.000000 26.000000 L 24.000000 82.000000 L 72.000000 82.000000 L 72.000000 26.000000 L 61.000000 26.000000 Z M 55.000000 26.000000 L 41.000000 26.000000 L 41.000000 21.000000 C 41.000000 20.400000 41.400002 20.000000 42.000000 20.000000 L 48.000000 20.000000 L 54.000000 20.000000 C 54.599998 20.000000 55.000000 20.400000 55.000000 21.000000 L 55.000000 26.000000 Z",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    fill: "#F2F2F2",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageW);
export default __webpack_public_path__ + "static/media/Luggage_w.dc9eab77cdad931ec255b5fc004080aa.svg";
export { ForwardRef as ReactComponent };